import { generalCallbacks } from './general';
import { findTestFormField } from '../helpers/detect-form-test';
const consentModifierCallback = (callbackData) => {
    const data = generalCallbacks.submitModifierCallback(callbackData);
    if (data === null) {
        return null;
    }
    const testField = findTestFormField();
    if (testField) {
        data[testField.name] = testField.value;
    }
    data.submit_id_c = callbackData.formContainer.dataset.originalSubmitId;
    return data;
};
export const consentCallbacks = {
    consentModifierCallback,
};
